import InstructorCard from './InstructorCard'
import burcu_alacam from "../assets/images/manager/burcu_alacam.jpg";

const ProjectManager = () => {
  return (
    <section id='instructors'>
        <h2>Proje Yürütücüsü</h2>
        <div className="cards">
            <InstructorCard
                name={"Burcu ALAÇAM"}
                title={"Dr. Öğr. Üyesi"}
                image = {burcu_alacam}
                url = {"https://avesis.atauni.edu.tr/burcu.alacam"}
            /> 
        </div>
    </section>
  )
}

export default ProjectManager;